<!--
 * @Description: 通知公告 已读
 * @Author: 裴孚
 * @Date: 2023-04-13 10:39:58
 * @LastEditors: 裴孚
 * @LastEditTime: 2023-05-30 13:52:00
-->
<template>
  <div class="tan-chuang">
    <el-dialog class="w800 h630" :model-value="openYiDu" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">通知公告</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openYiDu', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>

      <div class="list-page ml0 mr0">
        <el-container>
          <el-header>
            <!-- 搜索区域 BEGIN -->
            <el-form class="search-box" :model="dataGrid.parms">
              <el-form-item class="mr10">
                <el-input placeholder="标题" class="filter-item" v-model="dataGrid.parms.bt" clearable />
              </el-form-item>
              <el-button type="success" @click="bindTable()"><i class="el-icon--left bi bi-search"></i>查询</el-button>
            </el-form>
            <!-- 搜索区域 END -->
            <el-tabs v-model="activeName" class="demo-tabs" @tab-change="handleClick">
              <el-tab-pane label="全部" :name="9" ></el-tab-pane>
              <el-tab-pane label="未读" :name="0"></el-tab-pane>
              <el-tab-pane label="已读" :name="1"></el-tab-pane>
            </el-tabs>
          </el-header>
          <el-main>
            <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <!-- 冻结列-Left BEGIN -->
              <el-table-column label="序号" type="index" width="80" fixed header-align="center" align="center" />
              <!-- 冻结列-Left END -->
              <el-table-column label="标题" prop="bt" header-align="center" align="center" min-width="80" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                <template #default="scope">
                  <el-button type="primary" link @click="openDetail=true;row=scope.row">{{scope.row.bt}}</el-button>
                </template>
              </el-table-column>
              <el-table-column label="发布时间" prop="fbsj" header-align="center" align="center" width="160" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <!-- <el-table-column v-if="activeName==1" label="阅读时间" prop="ydsj" header-align="center" align="center" width="160" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" /> -->
            </el-table>
          </el-main>
        </el-container>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          <div class="footer-but">
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" @ReturnData="yidu" />
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadList, closeWindow } from '@/api/common.js'
import detail from '@/components/home/tongzhigonggao/detail'
import pagination from '@/components/pagination'

const props = defineProps({
  openYiDu: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openYiDu'])
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'fbsj', order: 'descending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const activeName = ref(9)
const handleClick = (val) => {
  activeName.value = val
  // return
  if (val === 0) {
    dataGrid.value.parms.zt = activeName.value
    dataGrid.value.orderBy.prop = 'fbsj'
  } else if (val === 1) {
    dataGrid.value.parms.zt = activeName.value
    dataGrid.value.orderBy.prop = 'ydsj'
  } else {
    dataGrid.value.parms.zt = undefined
    dataGrid.value.orderBy.prop = 'fbsj'
  }
  bindTable()
}
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/bangong/tongzhigonggaojieshouren/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.multipleSelection = []
    }
  })
}
const yidu = () => {
  emits('ReturnData')
  bindTable()
}
const row = ref()
const openDetail = ref(false)
watch(
  () => props.openYiDu,
  () => {
    if (props.openYiDu) {
      activeName.value = 9
      bindTable()
    }
  },
  { deep: true, immediate: true }
)
</script>
